import { CourseContentCount } from './Request';

export const contentCount = async courseId => {
  const contentCountValue = await CourseContentCount({ courseId });

  return contentCountValue;
};

export default {
  contentCount,
};
